import { render, staticRenderFns } from "./Newsletter.html?vue&type=template&id=4c70a280&scoped=true&external"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
import style0 from "./Newsletter.scss?vue&type=style&index=0&id=4c70a280&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70a280",
  null
  
)

export default component.exports